import "./Register.css";
import { useEffect, useState, forwardRef } from "react";
import bannerImg from "../../../assets/Images/login.png";
import Form from "react-bootstrap/Form";
import Snackbar from "@mui/material/Snackbar";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa";
import Slide from "@mui/material/Slide";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { loginUser } from "../../../redux/slices/login";
import Spinner from "react-bootstrap/Spinner";
import LoginBanner from "../../../assets/Images/login-banner.png";
import Logo from "../../../assets/Images/Logo.png";
import { Link } from "react-router-dom";

const Register = () => {
  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.login);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    Transition: Slide,
  });
  const { vertical, horizontal, open, Transition } = state;

  const handleClick = (newState) => {
    setState({ ...newState, open: true, Transition });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [isOpenEye, setIsOpenEye] = useState(false);
  const [isPassword, setIsPassword] = useState(true);
  const [validated, setValidated] = useState(false);

  const [loginInfo, setLoginInfo] = useState({
    user_mobile: "",
    pwd: "",
  });

  const email = "testuser@example.com";
  const subject = "Hello from React";
  const body = "Hi there,\n\nI wanted to reach out to you...";

  const handleEmailCompose = () => {
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, "_blank");
  };

  const handleOpenEye = () => {
    setIsOpenEye(!isOpenEye);
    setIsPassword(!isPassword);
  };

  const loginHandelChange = (e) => {
    const { name, value } = e.target;
    setLoginInfo((pr) => ({ ...pr, [name]: value }));
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
    //   dispatch(loginUser(loginInfo));
    }
  };

  useEffect(() => {
    if (loginState.authSuccess) {
      localStorage.setItem("user_data", JSON.stringify(loginState.authData));
      if (loginState.authData.user_id == 1) {
        localStorage.setItem("auth", true);
        localStorage.setItem("superadmin", true);
        return window.location.reload();
      } else {
        localStorage.setItem("auth", true);
        return window.location.reload();
      }
    }
    if (loginState.authError) {
      toast.error(loginState.authMessage);
    }
  }, [loginState.authSuccess, loginState.authError]);

  return (
    <div className="login-page">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
      <div className="login-left">
        <img
          src={LoginBanner} // Change this to your team image login-form
          alt="login banner"
          className="team-image"
        />
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <div className="d-flex align-items-center justify-content-center">
            <img src={Logo} alt="logo" className="login-logo" />
          </div>
          <div className="login-title d-flex align-items-center justify-content-center">
            <h2>Forgot Password?</h2>
          </div>
          <div className="sub-title mb-3 d-flex align-items-center justify-content-center">
            <p>
              Remember your password? <Link to="/login">Login Here</Link>
            </p>
          </div>

          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="login-form"
          >
            <Form.Group>
              <Form.Label htmlFor="email">Email Address</Form.Label>
              <Form.Control
                name="user_mobile"
                type="email"
                value={loginInfo.user_mobile}
                id="email"
                placeholder="Enter your email address"
                onChange={loginHandelChange}
                defaultValue={"new-password"}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid email id.
              </Form.Control.Feedback>
            </Form.Group>

            <button type="submit" className="login-button">
              Submit
            </button>
          </Form>

          <p className="help-text">
            Need help? <a href="#" onClick={handleEmailCompose}>Contact your system administrator.</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
